export default __webpack_public_path__ + "static/media/Dale Carnegie.efc5e750.png";